import type { FC } from "react";
import { ASSISTANT_AVATAR } from "@/theme/tokens";

const { ACCESSORY } = ASSISTANT_AVATAR;

/** Sunglasses. They replace the eyes, so the caller skips the eyes while these are on. */
export const AvatarShades: FC = () => (
	<>
		<path d="M31 53 H57 V61 Q57 71 44 71 Q31 71 31 61Z M63 53 H89 V61 Q89 71 76 71 Q63 71 63 61Z" fill={ACCESSORY.SHADES} />
		<path d="M57 55 H63" stroke={ACCESSORY.SHADES} strokeWidth={3} />
		<path d="M35 56 L41 56" stroke={ACCESSORY.SHADES_GLINT} strokeWidth={2} strokeLinecap="round" />
		<path d="M67 56 L73 56" stroke={ACCESSORY.SHADES_GLINT} strokeWidth={2} strokeLinecap="round" />
	</>
);
